import { call, put } from 'redux-saga/effects';
import {
  downloadSignedDocRequest,
  downloadSignedDocSuccess,
  downloadSignedDocFailure,
} from '../actions';
import { urls } from '../constants/constants';
import * as SagaTypes from './saga-types';
import * as Api from '../api';

export function* downloadSignedDocByPatient(action) {
  yield put(downloadSignedDocRequest());

  const patientId = action.payload.param.patientId;
  const filename = action.payload.param.filename || 'signed_document.zip';

  try {
    const result = yield call(
      Api.download,
      `${urls.aspariaBackend}api/v1/patient/downloadSignedDoc/${patientId}`,
      filename
    );
    if (result) {
      action.callback(result);
      yield call(
        Api.post,
        `${urls.aspariaBackend}api/v1/patient/signedDownloaded/${patientId}`
      );
      yield put(downloadSignedDocSuccess());
    } else {
      yield put(downloadSignedDocFailure('Something went Wrong'));
    }
  } catch (e) {
    yield put(downloadSignedDocFailure(e));
  }
}

export const downloadSignedDocSagaAction = (param, cb) => ({
  type: SagaTypes.DOWNLOAD_SIGNED_DOC,
  payload: { param },
  callback: cb,
});
